module.exports = __webpack_public_path__ + "img/phder.ee92a5d9.png";